import requestModel from "./apiHandlers";

export async function postContactUs(reqObj) {

    const requsetObj = {
        url : 'contact',
        method : "post",
        reqObj,
    }

    return await requestModel.response(requsetObj);
    
}